(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("lodash")) : factory(root["lodash"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);

// import {PanelBody, SelectControl, Toolbar, IconButton} from '@wordpress/components';
// import {Fragment} from '@wordpress/element';
// import {__} from '@wordpress/i18n';
// import {addFilter} from '@wordpress/hooks';
// import {createHigherOrderComponent} from '@wordpress/compose';
// import {InspectorControls, BlockControls} from '@wordpress/editor';

var __ = wp.i18n.__;
var addFilter = wp.hooks.addFilter;
var createHigherOrderComponent = wp.compose.createHigherOrderComponent;
var Fragment = wp.element.Fragment;
var _wp$editor = wp.editor,
    InspectorControls = _wp$editor.InspectorControls,
    BlockControls = _wp$editor.BlockControls;
var _wp$components = wp.components,
    PanelBody = _wp$components.PanelBody,
    SelectControl = _wp$components.SelectControl;


var availableLanguages = [{ value: '', label: __('Other', 'fvch') }, { value: 'bash', label: __('Bash', 'fvch') }, { value: 'css', label: __('CSS', 'fvch') }, { value: 'javascript', label: __('Javascript', 'fvch') }, { value: 'html', label: __('HTML', 'fvch') }, { value: 'php', label: __('PHP', 'fvch') }, { value: 'xml', label: __('XML', 'fvch') }];

var addCodeLanguageAttribute = function addCodeLanguageAttribute(settings, name) {
    if ('core/code' !== name) {
        return settings;
    }

    settings.attributes = Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["assign"])(settings.attributes, {
        language: {
            type: 'string',
            default: ''
        }
    });

    return settings;
};

addFilter('blocks.registerBlockType', 'fv-code-highlighter/attribute/language', addCodeLanguageAttribute);

var codeLanguageSelect = createHigherOrderComponent(function (BlockEdit) {
    return function (props) {
        // Do nothing if it's another block than our defined ones.
        if ('core/code' !== props.name) {
            return wp.element.createElement(BlockEdit, props);
        }

        var setAttributes = props.setAttributes;
        var language = props.attributes.language;


        return wp.element.createElement(
            Fragment,
            null,
            wp.element.createElement(BlockEdit, props),
            wp.element.createElement(
                InspectorControls,
                null,
                wp.element.createElement(
                    PanelBody,
                    {
                        title: 'FV Code Highlighter',
                        initialOpen: true
                    },
                    wp.element.createElement(SelectControl, {
                        label: 'Language',
                        value: language,
                        options: availableLanguages,
                        onChange: function onChange(value) {
                            return setAttributes({ language: value });
                        }
                    })
                )
            )
        );
    };
}, 'codeLanguageSelect');

addFilter('editor.BlockEdit', 'efv-code-highlighter/code-language-select', codeLanguageSelect);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// gutenberg.js